import { ReactNode } from 'react'

import { MultiScrollProvider } from '@/shared/lib'
import { Button, Dialog } from '@/shared/ui'

import { ApplyButton } from './apply-button'
import { Floors } from './floors'
import { Options } from './options'
import { PropertyTypes } from './property-types'
import { PyeongSizes } from './pyeong-sizes'
import { ResetButton } from './reset-button'
import { RoomCounts } from './room-counts'
import { RoomDiscounts } from './room-discounts'
import { UsingFee } from './using-fee'
import { Filter, FilterProvider } from '../../model/filter'

type TriggerProps = {
  target?: Filter
  children: ReactNode
}

export const FilterDialogTrigger = ({ target, children }: TriggerProps) => {
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>{children}</Dialog.Trigger>
      <Dialog.Content className="h-[760px] gap-0 p-0">
        <FilterDialog target={target} />
      </Dialog.Content>
    </Dialog.Root>
  )
}

export const FilterDialog = ({ target }: Pick<TriggerProps, 'target'>) => {
  return (
    <MultiScrollProvider target={target}>
      <FilterProvider>
        <Dialog.Header className="p-6">
          <Dialog.Title>필터</Dialog.Title>
          <Dialog.Description className="hidden">
            필터를 적용하여 더 정확한 검색 결과를 얻으세요
          </Dialog.Description>
        </Dialog.Header>
        <div className="scrollbar thick flex grow flex-col overflow-y-auto">
          <div className="mb-2 flex items-center justify-end pr-4 pl-6">
            <ResetButton />
          </div>
          <RoomCounts />
          <UsingFee />
          <PropertyTypes />
          <PyeongSizes />
          <Floors />
          <Options />
          <RoomDiscounts />
        </div>
        <Dialog.Footer className="flex flex-row gap-2.5 p-6">
          <Dialog.Close asChild>
            <Button variant="outline" size="large" fullWidth>
              닫기
            </Button>
          </Dialog.Close>
          <ApplyButton />
        </Dialog.Footer>
      </FilterProvider>
    </MultiScrollProvider>
  )
}
